import React from "react";
import Failed from "../lottie/Animation - 1704888436503.json";
import Lottie from "react-lottie";

const Fail = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Failed,
  };
  return (
    <div className="container">
      <Lottie options={defaultOptions} height={300} width={300} />
      <h4>Payment Failed</h4>
      {/* <br />
      <center>
        {" "}
        ನೀವು ಈಗಾಗಲೇ ಕೆ.ಆರ್.ಎಸ್ ಪಕ್ಷದ ಜೊತೆ ಕೈ ಜೋಡಿಸಿದ್ದೀರಿ.
        <br /> ಧನ್ಯವಾದಗಳು.
        <br />
        <br />
        <a class="button-4" href="https://your-whatsapp-link">
          {" "}
          ನಿಮ್ಮ Your District ಜಿಲ್ಲೆಯ KRS ಪಕ್ಷದ WhatsApp ಗ್ರೂಪ್ ಸೇರಲು ಇಲ್ಲಿ
          ಕ್ಲಿಕ್ ಮಾಡಿ{" "}
        </a>
        <br />
        <a
          class="button-4"
          href="https://wa.me/+91your-mobile-number?text=https://your-whatsapp-link"
        >
          ಸೇರ್ಪಡೆಗೊಂಡ ನೂತನ ಸದಸ್ಯರಿಗೆ WhatsApp ಗ್ರೂಪ್ ಲಿಂಕ್ ಕಳುಹಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್
          ಮಾಡಿ
        </a>
        <br />
        <br />
        ಹೆಸರು : Your Member Name
        <br />
        ನಿಮ್ಮ ಸದಸ್ಯತ್ವ ಸಂಖ್ಯೆ : OLyour-member-id{" "}
      </center>
      <br />

      <center>
        ಪಾವತಿ ವಿವರಗಳು
        <br />
        <table border="1">
          <tr>
            <th>ರೆಫರೆನ್ಸ್ ಸಂಖ್ಯೆ</th>
            <th>ದಿನಾಂಕ</th>
            <th>ಮೊತ್ತ</th>
          </tr>
          <tr>
            <td>Your Bank Ref No</td>
            <td>Your Date of Join</td>
            <td>
              <i class="fa fa-inr"></i> Your Amount Paid
            </td>
          </tr>
        </table>
        <br />
        <a class="button-4" href="Your-Main-Home-Page-URL">
          <b>ಮುಖ ಪುಟ</b>
        </a>
      </center> */}
    </div>
  );
};

export default Fail;
